export default {
  isAuthenticated(state){
    return state.signedIn;
  },

  getUser(state){
    return state.curUser;
  }
}
